import {ItemModelType, WorkspaceModelType} from "@stores/WorkspaceStore";

export const captureStatusProvenance = (
    workspace: WorkspaceModelType,
    item: ItemModelType
) => {
    const restoreParentIds = item.parentIds.length > 0
        ? item.parentIds.toJSON()
        : item.statusRestoreParentIds.toJSON();

    // Libraries live at workspace root (workspace.childIds), not inside another library.
    // getStatusSourceLibraryIdForItem returns a library's own ID if the item IS a library,
    // which causes a self-reference bug when restoring from trash.
    item.setStatusSourceLibraryId(item.isLibrary ? null : workspace.getStatusSourceLibraryIdForItem(item.id));
    item.setStatusRestoreParentIds(restoreParentIds);
};

export const clearStatusProvenance = (item: ItemModelType) => {
    item.setStatusSourceLibraryId(null);
    item.setStatusRestoreParentIds([]);
};

export const getLiveStatusRestoreParents = (
    workspace: WorkspaceModelType,
    item: ItemModelType
): ItemModelType[] => {
    return item.statusRestoreParentIds
        .map(parentId => workspace.items.get(parentId))
        .filter((parent): parent is ItemModelType => {
            return !!parent && parent.id !== item.id && !parent.trashed && !parent.archived;
        });
};

export const getStatusSourceLibrary = (
    workspace: WorkspaceModelType,
    item: ItemModelType
): ItemModelType | null => {
    const libraryId = item.statusSourceLibraryId;
    const library = libraryId ? workspace.items.get(libraryId) : null;

    if (library && library.isLibrary && !library.trashed && !library.archived) {
        return library;
    }

    return null;
};
